import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseCompanyPriceSurveysProps<T> = {
  filters?: {
    companyId?: string
    cityId?: string
    status?: string
    productId?: string
    surveyConductedAtGt?: string
    surveyConductedAtLt?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useCompanyPriceSurveys = <T,>({
  filters: { companyId, cityId, status, productId, surveyConductedAtGt, surveyConductedAtLt, page } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyPriceSurveysProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companyPriceSurveys', companyId, cityId, status, productId, surveyConductedAtGt, surveyConductedAtLt, page],
    queryFn: () => {
      return privateAxios.get('/client/price_surveys', {
        params: {
          'q[company_id_eq]': companyId,
          'q[city_id_eq]': cityId,
          'q[status_eq]': status,
          'q[product_id_eq]': productId,
          'q[survey_conducted_at_gteq]': surveyConductedAtGt,
          'q[survey_conducted_at_lteq]': surveyConductedAtLt,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
